import { withSentryAssertion } from '@/helpers/withSentryAssertion'

import {
  array,
  bool,
  CheckerReturnType,
  literal,
  nullable,
  number,
  object,
  optional,
  // or,
  string,
  union,
} from '@recoiljs/refine'
import { BCAddress } from './BCAddresses'
import { BCCart, BCCartCoupon } from './BCCart'

export const BCCheckoutGiftCertificate = object({
  balance: number(),
  code: string(),
  purchaseDate: string(),
  remaining: number(),
  used: number(),
})

export const BCCheckoutConsignmentShippingOption = object({
  description: string(),
  id: string(),
  type: string(),
  imageUrl: string(),
  cost: number(),
  transitTime: string(),
  isRecommended: optional(bool()),
})

export type BCCheckoutConsignmentShippingOptionType =
CheckerReturnType<typeof BCCheckoutConsignmentShippingOption>

export const BCCheckoutConsignment = object({
  id: string(),
  shippingAddress: BCAddress,
  address: BCAddress,
  availableShippingOptions: array(BCCheckoutConsignmentShippingOption),
  selectedShippingOption: nullable(BCCheckoutConsignmentShippingOption),
  couponDiscounts: array(object({
    code: string(),
    amount: number(),
  })),
  // discounts: array(object({ id: or(string(), number()) })),
  shippingCost: number(),
  handlingCost: number(),
  lineItemIds: array(string()),
})

export type BCCheckoutConsignmentType = CheckerReturnType<typeof BCCheckoutConsignment>

export const BCCheckout = object({
  id: string(),
  cart: BCCart,
  billingAddress: BCAddress,
  consignments: array(BCCheckoutConsignment),
  coupons: array(BCCartCoupon),
  orderId: union(string(), number(), literal(null)),
  shippingCostTotal: number(),
  giftWrappingCostTotal: number(),
  handlingCostTotal: number(),
  taxTotal: number(),
  taxes: array(object({
    name: string(),
    amount: number(),
  })),
  shippingCostBeforeDiscount: number(),
  subtotal: number(),
  grandTotal: number(),
  outstandingBalance: number(),
  isStoreCreditApplied: bool(),
  shouldExecuteSpamCheck: bool(),
  giftCertificates: optional(array(BCCheckoutGiftCertificate)),
  createdTime: string(),
  updatedTime: string(),
  customerMessage: string(),
  channelId: number(),
})

export type BCCheckoutType = CheckerReturnType<typeof BCCheckout>

export const assertBCCheckout = withSentryAssertion([BCCheckout, 'Bigcommerce Checkout'])
